import { IMenuItem } from '../../models/menu.model';

/**
 * Menu configuration for Commissioner Desk.
 * Contains menu items for dashboard.
 */
export const commissionerMenu: IMenuItem = {
  label: `Commissioner`,
  path: `commissioner`,
  id: 'MID_COMMISSIONER',
  icon: 'fa fa-flag',
  children: [{ path: `dashboard`, label: `Dashboard`, id: 'MID_COMMISSIONER_DASHBOARD' }],
};
